export const errorCodesDictionary = {
  // sec
  'sec.auth_data_invalid': 'Incorrect email or password',
  // bus
  'bus.email_already_exists':
    'This email is already registered. Sign in or use different email to register.',
  'bus.password_reset_request_invalid':
    'Invalid password reset request. Please request a new password reset link.',
};

export const BUS_USER_IS_BLOCKED = 'bus.user_is_blocked';
export const BUS_ASSOCIATION_REQUEST_COUNTER =
  'bus.association_request_counter';
